/**
 * TODO: we'll migrate this cookie helper to have native cookie store compatibility
 * biome-ignore-all lint/suspicious/noDocumentCookie: need to plan migration
 */
export type CookieValue = string | null | undefined;

export type Cookies = Record<string, CookieValue>;

export interface CookieOptions {
	maxAge?: number | undefined;
	signed?: boolean | undefined;
	expires?: Date | undefined;
	httpOnly?: boolean | undefined;
	path?: string | undefined;
	domain?: string | undefined;
	secure?: boolean | undefined;
	sameSite?: boolean | 'lax' | 'strict' | 'none' | undefined;
}

export interface CookieHelpers {
	getCookie(key: string): CookieValue;
	getAllCookies(): Cookies;
	setCookie(key: string, value: CookieValue, opts?: CookieOptions): void;
	clearCookie(key: string): void;
	syncCookies: () => void;
}

const SAME_SITE_COOKIES = [
	'at',
	'ixiUID',
	'pwaSdkScope',
	'sapphire',
	'clientId',
];

export function parseCookies(): Cookies {
	const cookies: Cookies = {};
	return typeof window !== 'undefined'
		? document.cookie.split(';').reduce((cookies, cookie) => {
				const [name, val] = cookie?.trim().split('=') || [];
				if (!name || !val) return cookies;
				cookies[name] = decodeURIComponent(
					val.replace(/^"/, '').replace(/"$/, ''),
				);
				return cookies;
			}, cookies)
		: cookies;
}

/**
 *
 * @param time number of days from today when cookie will expire or will be defaulted to 20 year from now
 * @returns a set of common cookie options
 */
function cookieOptions(time?: number) {
	return {
		path: '/',
		// domain: '.ixigo.com',
		expires: time ? new Date(Date.now() + time * 86400000) : getExpiryTime(),
	};
}

/**
 * use it to get date after the 20 years from current date
 */
function getExpiryTime() {
	const expires = new Date();
	expires.setFullYear(expires.getFullYear() + 20);
	return expires;
}

export function writeCookie(
	key: string,
	value: number | string | boolean,
	{ domain, expires }: CookieOptions = {},
) {
	let cookieStr = `${key}=${value};${expires ? `expires=${expires.toUTCString()};` : ''}${`path=/;`}${domain ? `domain=${domain};` : ''}`;
	// setting cookie in iframe (this will be helpfull for SSO)
	if (SAME_SITE_COOKIES.includes(key)) cookieStr += 'SameSite=None;Secure;';
	document.cookie = cookieStr;
}

export const getCookieHelpers = (seedCookies?: Cookies): CookieHelpers => {
	let parsedCookies = seedCookies || parseCookies();
	return {
		getCookie: (key: string) => parsedCookies[key],
		getAllCookies: () => ({ ...parsedCookies }),
		setCookie: (key: string, val: string, opts?: object) => {
			writeCookie(key, val, { ...cookieOptions(), ...opts });
			parsedCookies[key] = val;
		},
		clearCookie: (key: string) => {
			let cookieStr = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;`;
			if (SAME_SITE_COOKIES.includes(key)) cookieStr += 'SameSite=None;Secure';
			document.cookie = cookieStr;

			//Also try to delete the cookie from the main domain
			cookieStr = `${key}=;domain=.ixigo.com;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;`;
			if (SAME_SITE_COOKIES.includes(key)) cookieStr += 'SameSite=None;Secure';
			document.cookie = cookieStr;
		},
		syncCookies: (seedCookies?: Cookies) => {
			const cookies = seedCookies || parseCookies();
			parsedCookies = cookies;
		},
	};
};

/**
 * Cookie store for the application. use on the client side only.
 */
export const cookieStore = /*#__PURE__*/ getCookieHelpers();
